export default __webpack_public_path__ + "static/circle-datacenter-a3eb9bbeec69947e32e9e3f7e0aa87c1.png";